import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface localProductContext extends ProductContextModel {
    product: ProductModel & {altText?: string; smallImagePath?: string };
}
interface OwnProps {
    product: CartLineModel & localProductContext;
    extendedStyles?: ProductImageStyles;
    sourceName?: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state)?.pathname;
    return {
        location,
    };
};

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
         @media only screen and (max-width: 576px) {
            display:flex;
            justify-content:center;
         }`,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto !important;
            width: 100% !important;
            margin: 0 10px 0 10px;
        `,
    },
};

const ProductImage: FC<Props> = ({ location, product, extendedStyles, sourceName }) => {
    const [styles] = React.useState(() => mergeToNew(productImageStyles, extendedStyles));

    if (!product) {
        return null;
    }

    let altText;
    if (product) {
        altText = product?.product?.imageAltText || product?.product?.altText || product?.altText;
    }
    // below OOTB code has been commented to address the requirement of the ticket ADINA-45633.
    // altText += ` ${translate("redirect to product page")}`;
    const loading = product?.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";
    const imagePath = product?.product?.mediumImagePath || product?.product?.smallImagePath || product?.smallImagePath;

    const productCatologUrl = product?.product?.productUri || product?.productUri;
    // ADINA-42734 : Brands routing
    let productBrandUrl = product?.product?.urlSegment || product?.productUri;
    if (
        product &&
        "product" in product &&
        product?.product?.variantTypeId &&
        !productBrandUrl.includes("?option=") &&
        product?.product?.canonicalUrl.includes("?option=")
    ) {
        productBrandUrl = product?.product?.canonicalUrl.replace("/product/", "").replace("", "");
    }
    let hrefValue = "";

    if (location.toLowerCase().includes("/catalog/shop-brands") && productBrandUrl) {
        hrefValue = `${location  }/${  productBrandUrl.replace("/Product/", "").replace("", "")}`;
    } else {
        hrefValue = productCatologUrl;
    }

    const clickHandler = () => {
        sessionStorage.setItem("item_list_name", sourceName ?? "");
    };

    return (
        <Clickable {...styles.linkWrappingImage} href={hrefValue} data-test-selector="productImage">
            <Img {...styles.img} loading={loading} src={imagePath} altText={altText} onClick={clickHandler} />
        </Clickable>
    );
};

export default connect(mapStateToProps)(ProductImage);
